export function initExploreTabs() {
	exploreTabs();
}

function exploreTabs() {
	$( document ).on( 'change', '.section-explore-tabs .nav-select-child' , function() {
		$( this ).closest( '.tab-pane' ).find( '.tab-pane' ).removeClass( 'show active' );
		$( this ).closest( '.section-explore-tabs' ).find( '#v-pills-' + $( this ).val() ).tab( 'show' );
	} );
}



// WEBPACK FOOTER //
// ./scripts/components/exploreTabs.ts